import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="w-full mb-6 md:mb-8 lg:mb-10">
      <div className="flex items-center justify-between mb-3 md:mb-4">
        <span className="text-xs md:text-sm font-caption text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-xs md:text-sm font-caption font-medium text-foreground">
          {Math.round((currentStep / totalSteps) * 100)}% Complete
        </span>
      </div>
      <div className="relative">
        <div className="h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-therapeutic"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          />
        </div>

        <div className="flex justify-between mt-4 md:mt-6">
          {steps?.map((step, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;
            const isUpcoming = stepNumber > currentStep;

            return (
              <div
                key={step?.id}
                className="flex flex-col items-center space-y-2 flex-1"
              >
                <div
                  className={`
                    flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full
                    transition-therapeutic
                    ${isCompleted ? 'bg-primary text-primary-foreground' : ''}
                    ${isCurrent ? 'bg-primary text-primary-foreground ring-4 ring-primary/20' : ''}
                    ${isUpcoming ? 'bg-muted text-muted-foreground' : ''}
                  `}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={16} color="currentColor" />
                  ) : (
                    <span className="text-xs md:text-sm font-medium">{stepNumber}</span>
                  )}
                </div>
                <span
                  className={`
                    text-xs md:text-sm font-caption text-center max-w-[80px] md:max-w-none
                    ${isCurrent ? 'text-foreground font-medium' : 'text-muted-foreground'}
                  `}
                >
                  {step?.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;